(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("ProtvistaZoomable"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "ProtvistaZoomable"], factory);
	else if(typeof exports === 'object')
		exports["ProtvistaTrack"] = factory(require("d3"), require("ProtvistaZoomable"));
	else
		root["ProtvistaTrack"] = factory(root["d3"], root["ProtvistaZoomable"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__10__) {
return 